const PomeloPinsConstant = Object.freeze({
  checkOutContainerClassName: 'checkout-methods-container',
  minimumPinLocation: 10,
  getPickUpLocation: 'GET_TH_PICKUP',
  store: 'store|pin',
  tempDisabled: 'temporary-disable',
})

export default PomeloPinsConstant
